import { MeasureCodeDTO } from 'csr-asset-app';

// TODO: IMPLEMENTATION_ORDER can be removed when it is part of the API
export const IMPLEMENTATION_ORDER: MeasureCodeDTO[] = [
  MeasureCodeDTO.LEDLIGHTINGINSTEADOFCFL,
  MeasureCodeDTO.LEDLIGHTINGINSTEADOFINCANDESCENTBULBS,
  MeasureCodeDTO.LEDLIGHTINGINSTEADOFHALOGEN,
  MeasureCodeDTO.LEDLIGHTINGINSTEADOFFLUORESCENTTUBES,
  MeasureCodeDTO.LEDPANELS,
  MeasureCodeDTO.LEDBILLBOARDLIGHTING,
  MeasureCodeDTO.LEDFIELDLIGHTING,
  MeasureCodeDTO.REPLACEOUTDOORLIGHTING,
  MeasureCodeDTO.SOLARPOWEREDSTREETLIGHTS,
  MeasureCodeDTO.SMARTTHERMOSTATS,
  MeasureCodeDTO.CENTRALISEDLIGHTINGCONTROL,
  MeasureCodeDTO.LIGHTINGMOTIONSENSORS,
  MeasureCodeDTO.OUTDOORLIGHTINGSENSORS,
  MeasureCodeDTO.DAYLIGHTRESPONSIVELIGHTING,
  MeasureCodeDTO.DRAUGHTPROOFING,
  MeasureCodeDTO.REDUCEAIRPERMEABILITY,
  MeasureCodeDTO.ROOFINSULATION,
  MeasureCodeDTO.WALLINSULATION,
  MeasureCodeDTO.REPLACEWINDOWS,
  MeasureCodeDTO.REPLACEDOORS,
  MeasureCodeDTO.REPLACEROOFWINDOW,
  MeasureCodeDTO.FLOORINSULATION,
  MeasureCodeDTO.WINDOWFILM,
  MeasureCodeDTO.SMARTWINDOWS,
  MeasureCodeDTO.SOLARSHADING,
  MeasureCodeDTO.WHITEROOFCOATING,
  MeasureCodeDTO.CONDENSINGBOILERHEATING,
  MeasureCodeDTO.CONDENSINGBOILERTAPWATER,
  MeasureCodeDTO.HEATRECOVERYVENTILATION,
  MeasureCodeDTO.ENERGYEFFICIENTVENTILATION,
  MeasureCodeDTO.SOLARPANELS,
  MeasureCodeDTO.SOLARTHERMALCOLLECTORS,
  MeasureCodeDTO.SMALLSCALEWINDTURBINES,
  MeasureCodeDTO.AIRSOURCEHEATPUMPHYBRID,
  MeasureCodeDTO.AIRSOURCEHEATPUMP,
  MeasureCodeDTO.GASABSORPTIONHEATPUMP,
  MeasureCodeDTO.COMBINEDHEATANDPOWER,
  MeasureCodeDTO.SUSTAINABLECOOLING,
  MeasureCodeDTO.COOLINGUPGRADECHILLER,
  MeasureCodeDTO.COOLINGWATERCOOLEDCHILLER,
  MeasureCodeDTO.ENERGYMONITORING,
  MeasureCodeDTO.OPTIMISECLIMATECONTROLSYSTEM,
  MeasureCodeDTO.WEATHERCOMPENSATIONHEATINGSYSTEM,
  MeasureCodeDTO.WEATHERDEPENDENTCENTRALHEATINGGROUPS
];
